import { render, staticRenderFns } from "./SelectYourDiagnosticTemplate.vue?vue&type=template&id=0fcfb402&scoped=true"
import script from "./SelectYourDiagnosticTemplate.vue?vue&type=script&lang=js"
export * from "./SelectYourDiagnosticTemplate.vue?vue&type=script&lang=js"
import style0 from "./SelectYourDiagnosticTemplate.vue?vue&type=style&index=0&id=0fcfb402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcfb402",
  null
  
)

export default component.exports